import React from "react";

const StakeholdersMobile = ({ tableData }) => {
  return (
    <div className="all-leads-log mt30" style={{ rowGap: "1rem" }}>
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top" style={{ padding: "20px" }}>
                  <div className="profile-name-number">
                    <div className="name-number">
                      <h3 className="lead-name">
                        {row?.account_type?.replace(/_/g, " ") || ""}
                      </h3>

                      <div className="card-other-info p-0">
                        <span className="value semi-bold">
                          {row?.name || ""}
                        </span>
                        <span className="value semi-bold">
                          {row?.mobile || ""}
                        </span>
                        <span className="value email semi-bold">
                          {row?.email || ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default StakeholdersMobile;
